export default __webpack_public_path__ + "static/media/main-characters-padded-sm-2x.4fa2d797.jpg";